<template>
  <div class="task-modal-pricing">
    <div class="task-modal-pricing-hero">
      <span class="task-modal-pricing-hero-label">Total Cost (inc GST)</span>
      <h5 class="task-modal-pricing-hero-amount">${{ displayTotal }}</h5>
    </div>

    <div class="task-modal-pricing-cta">
      <slot name="cta"></slot>
    </div>

    <app-accordion-toggle
      :expanded="detailsOpen"
      expanded-label="Hide pricing details"
      collapsed-label="Show pricing details"
      align="center"
      class="task-modal-pricing-toggle"
      @toggle="onToggleDetails"
    />

    <div v-show="detailsOpen" class="task-modal-pricing-details">
      <app-task-modal-price-type-toggle
        :model-value="priceType"
        @update:model-value="$emit('update:priceType', $event)"
      />

      <div class="task-modal-pricing-breakdown">
        <div class="task-modal-pricing-row">
          <span class="task-modal-pricing-row-label">Profit cost</span>
          <span class="task-modal-pricing-row-value">${{ displayProductCost }}</span>
        </div>
        <div class="task-modal-pricing-row">
          <span class="task-modal-pricing-row-label">Profit markup</span>
          <span class="task-modal-pricing-row-value">{{ displayProductMargin }}</span>
        </div>
        <div class="task-modal-pricing-row">
          <span class="task-modal-pricing-row-label">Gross profit</span>
          <span class="task-modal-pricing-row-value">${{ displayGrossProfit }}</span>
        </div>
        <div class="task-modal-pricing-row">
          <span class="task-modal-pricing-row-label">Total GST</span>
          <span class="task-modal-pricing-row-value">${{ displayGst }}</span>
        </div>
        <div class="task-modal-pricing-row">
          <span class="task-modal-pricing-row-label">Labour</span>
          <span class="task-modal-pricing-row-value">{{ labourDisplay }}</span>
        </div>
      </div>
    </div>

    <app-pricing-pin-verification-modal
      :open="pinModalVisible"
      @close="pinModalVisible = false"
      @cancel="pinModalVisible = false"
      @verified="onPinVerified">
    </app-pricing-pin-verification-modal>
  </div>
</template>

<script>
import TaskModalPriceTypeToggle from './TaskModalPriceTypeToggle.vue'
import PricingPinVerificationModal from '../../../common/PricingPinVerificationModal.vue'
import { TASK_PRICE_TYPES } from '../../../../helpers/taskPricing'
import { isPricingProtectionEnabled } from '../../../../helpers/pricingPin'

export default {
  name: 'TaskModalCostSummary',
  components: {
    'app-task-modal-price-type-toggle': TaskModalPriceTypeToggle,
    'app-pricing-pin-verification-modal': PricingPinVerificationModal
  },
  props: {
    totalPrice: {
      type: [String, Number],
      required: true
    },
    productCost: {
      type: [String, Number],
      default: ''
    },
    productMarginPct: {
      type: [String, Number],
      default: ''
    },
    grossProfit: {
      type: [String, Number],
      default: ''
    },
    gstAmount: {
      type: [String, Number],
      default: ''
    },
    labourTime: {
      type: String,
      default: '-'
    },
    labourRate: {
      type: String,
      default: ''
    },
    priceType: {
      type: String,
      default: TASK_PRICE_TYPES.STANDARD
    }
  },
  data: function () {
    return {
      detailsOpen: false,
      pinModalVisible: false
    }
  },
  computed: {
    displayTotal: function () {
      return this.formatMoney(this.totalPrice)
    },
    displayProductCost: function () {
      return this.formatMoney(this.productCost)
    },
    displayProductMargin: function () {
      if (this.productMarginPct === '' || this.productMarginPct === '-') return '-'
      const n = Number(this.productMarginPct)
      if (!Number.isFinite(n)) return '-'
      return n + '%'
    },
    displayGrossProfit: function () {
      return this.formatMoney(this.grossProfit)
    },
    displayGst: function () {
      return this.formatMoney(this.gstAmount)
    },
    labourDisplay: function () {
      if (!this.labourTime || this.labourTime === '-') return '-'
      if (this.labourRate) {
        return this.labourTime + ' @ ' + this.labourRate
      }
      return this.labourTime
    }
  },
  methods: {
    formatMoney: function (value) {
      if (value === '' || value === '-' || value == null) return '-'
      const n = parseFloat(value)
      if (!Number.isFinite(n)) return '-'
      return n.toFixed(2)
    },
    onToggleDetails: function () {
      if (this.detailsOpen) {
        this.detailsOpen = false
        return
      }
      if (isPricingProtectionEnabled(this.$store)) {
        this.pinModalVisible = true
        return
      }
      this.detailsOpen = true
    },
    onPinVerified: function () {
      this.detailsOpen = true
      this.pinModalVisible = false
    }
  }
}
</script>
